module.exports = __webpack_public_path__ + "static/sc-02-99f62c563a503068ac3c98a65df405dd.png";